module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md8": "",
      "lg6": ""
    }
  }, [_c('v-card', {
    staticClass: "py-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    staticClass: "px-4",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.corporationName,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCorporationName)); }]
    },
    model: {
      value: (_vm.corporation.name),
      callback: function($$v) {
        _vm.$set(_vm.corporation, "name", $$v)
      },
      expression: "corporation.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.companies,
      "label": _vm.$lang.actions.selectCompanies,
      "rules": [function () { return _vm.corporation.companies.length !== 0 || ("" + (_vm.$lang.errors.missingCompanies)); }],
      "loading": _vm.companyLoading,
      "chips": "",
      "deletable-chips": "",
      "multiple": "",
      "item-text": "name",
      "item-value": "id"
    },
    on: {
      "change": function($event) {
        return _vm.filterCompanies()
      }
    },
    model: {
      value: (_vm.corporation.companies),
      callback: function($$v) {
        _vm.$set(_vm.corporation, "companies", $$v)
      },
      expression: "corporation.companies"
    }
  })], 1), _vm._v(" "), (_vm.corporation.companies.length > 0) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.filteredCompanies,
      "label": _vm.$lang.labels.primaryCompany,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.primaryCompany)); }],
      "required": "",
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.corporation.primaryCompanyId),
      callback: function($$v) {
        _vm.$set(_vm.corporation, "primaryCompanyId", $$v)
      },
      expression: "corporation.primaryCompanyId"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.settings), function(setting, index) {
    return _c('v-layout', {
      key: index,
      attrs: {
        "align-center": "",
        "wrap": "",
        "pa-2": "",
        "row": ""
      }
    }, [_c('v-flex', {
      staticStyle: {
        "min-width": "200px"
      },
      attrs: {
        "shrink": "",
        "px-3": ""
      }
    }, [_c('v-checkbox', {
      attrs: {
        "label": _vm.$lang.labels[setting],
        "hide-details": "",
        "color": "primary"
      },
      model: {
        value: (_vm.corporation[setting].enabled),
        callback: function($$v) {
          _vm.$set(_vm.corporation[setting], "enabled", $$v)
        },
        expression: "corporation[setting].enabled"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "grow": "",
        "px-3": "",
        "pt-2": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": ((_vm.$lang.labels[setting]) + " URL"),
        "rules": [
          (_vm.corporation[setting].serverUrl && _vm.corporation[setting].enabled) ||
          !_vm.corporation[setting].enabled ||
          _vm.$lang.errors.serverUrl
        ],
        "type": "text",
        "color": "primary"
      },
      model: {
        value: (_vm.corporation[setting].serverUrl),
        callback: function($$v) {
          _vm.$set(_vm.corporation[setting], "serverUrl", $$v)
        },
        expression: "corporation[setting].serverUrl"
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2 pb-4",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pt-2": ""
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$lang.labels.dailyOrderCounterPrefixes))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "wrap": "",
      "pa-2": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pr-1": "",
      "pt-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.delivery,
      "type": "text",
      "color": "primary",
      "maxlength": _vm.dailyOrderCounterPrefixesMax
    },
    model: {
      value: (_vm.corporation.dailyOrderCounterPrefixes.delivery),
      callback: function($$v) {
        _vm.$set(_vm.corporation.dailyOrderCounterPrefixes, "delivery", $$v)
      },
      expression: "corporation.dailyOrderCounterPrefixes.delivery"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "px-1": "",
      "pt-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.collection,
      "type": "text",
      "color": "primary",
      "maxlength": _vm.dailyOrderCounterPrefixesMax
    },
    model: {
      value: (_vm.corporation.dailyOrderCounterPrefixes.collection),
      callback: function($$v) {
        _vm.$set(_vm.corporation.dailyOrderCounterPrefixes, "collection", $$v)
      },
      expression: "corporation.dailyOrderCounterPrefixes.collection"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pl-1": "",
      "pt-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.takeaway,
      "type": "text",
      "color": "primary",
      "maxlength": _vm.dailyOrderCounterPrefixesMax
    },
    model: {
      value: (_vm.corporation.dailyOrderCounterPrefixes.takeaway),
      callback: function($$v) {
        _vm.$set(_vm.corporation.dailyOrderCounterPrefixes, "takeaway", $$v)
      },
      expression: "corporation.dailyOrderCounterPrefixes.takeaway"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [(_vm.isEdit && _vm.createdOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEdit && _vm.modifiedOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3 px-4",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-content-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'corporations'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.close) + "\n        ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-0",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isEdit ? _vm.$lang.actions.update : _vm.$lang.actions.create) + "\n        ")])], 1)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fa2c03f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/corporations/CorporationDetails.vue
// module id = 414
// module chunks = 35